import {initializeApp} from "firebase/app";
import {getAuth} from 'firebase/auth';
import {getFirestore} from "firebase/firestore";
import {getFunctions} from "@firebase/functions";
import {fetchAndActivate, getRemoteConfig} from "firebase/remote-config";
import remoteDefaultConfig from "./remote_config_defaults.json";

const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    databaseURL: process.env.REACT_APP_FIREBASE_FIRESTORE,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
}

export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const firestore = getFirestore(app);
export const functions = getFunctions(app, 'europe-west6');
export const remoteConfig = getRemoteConfig(app);

remoteConfig.defaultConfig = remoteDefaultConfig;
remoteConfig.settings.minimumFetchIntervalMillis = 1000;

fetchAndActivate(remoteConfig).then((res) => {
    console.log("Fetch and activate remote config");
}).catch((err) => {
    console.log(err);
});